import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutShiftPatternsOrderRequest, ResponseShiftPattern } from '@/model/repository';
import { compareShiftCategoricalItem } from '@/service/shift/categoryComparator';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * シフトパターンを並び替え
 */
export const updateShiftPatternOrders = async (patterns: ResponseShiftPattern[]) => {
  // APIでバックエンドのデータを新しい並び順で更新する
  const payload: PutShiftPatternsOrderRequest = {
    shiftCategoryId: patterns[0].shiftCategoryId,
    shiftPatternIds: patterns.filter((pattern) => !pattern.disabled).map((pattern) => pattern.shiftPatternId),
  };
  const response = await shiftServiceRepositories.shiftPatternsOrders.update(payload);
  // レスポンスのorderを画面のモデルに反映する
  const idOrderMap = response.data.reduce((map, pattern) => {
    map.set(pattern.shiftPatternId, pattern.order);
    return map;
  }, new Map<string, number>());
  const result = patterns.map((pattern) => ({
    ...pattern,
    order: idOrderMap.get(pattern.shiftPatternId) || 0,
  }));
  // ソート
  sortShiftPatterns(result);
  return result;
};

/**
 * シフトパターンのソート
 */
export const sortShiftPatterns = (shiftPatterns: ResponseShiftPattern[]) => {
  const patternMapper = (shiftPattern: ResponseShiftPattern) => ({
    id: shiftPattern.shiftPatternId,
    ...shiftPattern,
  });
  shiftPatterns.sort((a, b) => compareShiftCategoricalItem(patternMapper(a), patternMapper(b)));
};
